import React, {  } from 'react';
import Box from '@mui/material/Box';
import Divder from '../../Components/CommonComp/Divder';
import CustomBox from '../../Components/CommonComp/CustomBox/CustomBox';
import { LeftArrow } from '../../Asset/svg';
import { Typography, useTheme } from '@mui/material';
import CustomButton from '../../Components/CommonComp/Buttons/CustomButton';
import { useNavigate, useParams } from 'react-router-dom';
import MasterListFollowUps from '../../Components/FollowUps/MasterListFollowUps';
import MasterListMultipleFollowUps from '../../Components/FollowUps/MasterListMultipleFollowUps';

function MasterMultipleFollowUps() {
  const theme = useTheme();
  const navigate = useNavigate();
  const {order_ids} = useParams();

  return (
    <Box
      component="main"
      sx={(theme) => {
        return {
          flexGrow: 1,
        };
      }}
    >
      <CustomBox>
        <Box sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        }}> 
            <Box sx={{
                display: "flex",
                alignItems: "center",
                cursor: 'pointer'
            }} onClick={()=>{
                window.close();
            }}>
                <LeftArrow fill={theme.palette.textButton.main}/>
                <Typography variant='h5' sx={{
                    marginLeft: theme.spacing(1),
                    color: theme.palette.textButton.main
                }}>Back</Typography>
            </Box>
            <Typography variant='h5' sx={{marginLeft: (theme)=> theme.spacing(1)}}>History</Typography>
            <div style={{paddingLeft: 30}}></div>
        </Box>
      </CustomBox>
      <Divder spacing={1} />
      <MasterListMultipleFollowUps
       order_ids={order_ids}/>
      
      <Divder spacing={1.2} />
    </Box>
  );
}

export default MasterMultipleFollowUps;
